import React, {Component} from 'react';
import CompanyAttachModal from "./modals/CompanyAttachModal";
import BackEnd from '../../../backend/BackEnd';
import DataGrid from "../../../datagrid/DataGrid";
import DataColumn from "../../../datagrid/DataColumn";
import {withRouter} from "react-router";
import CompanyForm from "../Companies/CompanyForm";

class Contractors extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        showAttachCompanyModal: false,
        contractorId: 0
    };

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-ios-list-outline"/> Справочники /
                                </span> Контрагенты 1С
                            </h1>
                        </div>
                    </div>
                </div>
                <DataGrid ref={grid => this.grid = grid}
                          dataSource={new BackEnd.ContractorsAdmin.GetGridResult()}
                          gridId="ContractorGrid"
                          pageSize={15}>
                    <DataColumn fieldName="name" type="string"
                                caption="Название"
                                cell={contractor => contractor.name}/>
                    <DataColumn fieldName="fullName" type="string"
                                caption="Полное название"
                                cell={contractor => contractor.fullName}/>
                    <DataColumn fieldName="inn" type="string"
                                caption="ИНН"
                                cell={contractor => contractor.inn}/>
                    <DataColumn fieldName="address" type="string"
                                caption="Адрес"
                                cell={contractor => contractor.address}/>
                    <DataColumn fieldName="company" type="string"
                                caption="Компания"
                                cell={contractor =>
                                    contractor.company
                                        ? contractor.company.text
                                        : (
                                            <div>
                                                <button type="button" className="btn btn-default btn-sm m-r-1"
                                                        onClick={() => this.createCompany(contractor)}>
                                                    Создать компанию
                                                </button>
                                                <button type="button" className="btn btn-default btn-sm"
                                                        onClick={() => this.attachCompany(contractor)}>
                                                    Связать с компанией
                                                </button>
                                            </div>
                                        )
                                }/>
                    <DataColumn fieldName="isActive" type="string"
                                caption="Активен"
                                cell={contractor => contractor.isActive}/>
                </DataGrid>
                <CompanyAttachModal contractorId={this.state.contractorId}
                                    show={this.state.showAttachCompanyModal}
                                    onAttach={() => this.grid.fetchGridData()}
                                    onHide={() => this.setState({showAttachCompanyModal: false})}/>
            </div>
        );
    }

    createCompany({contractorId, name}) {
        this.props.history.push({
            pathname: '/catalogs/companies/create',
            state: {
                contractor: {id: contractorId, text: name}
            }
        });
    }

    attachCompany({contractorId}) {
        this.setState({showAttachCompanyModal: true, contractorId});
    }
}

export default withRouter(Contractors);


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Contractors/Contractors.js